import StudyPlanDetailsModal from "../../components/StudyPlanDetailsModal";
import SectionHeader from "./SectionHeader";
import { loadFeaturedPlans } from "../../lib/index/featuredPlans";

// subject -> color + short pill copy (presentation only). Insertion
// order doubles as `subjectOrder`: manifest entries are sorted by
// their position here, and subjects missing from this lookup are
// filtered out at render time. See docs/design-www-import-study-plans.md.
const pillDisplay = {
  Math: { color: "bg-pastelgreen", short: "Quadratics in sports, games, physics" },
  Geometry: { color: "bg-pastelgreen", short: "Shapes in bridges, honeycombs, art" },
  Science: { color: "bg-pastelblue", short: "Storms, hurricanes, climate zones" },
  Space: { color: "bg-pastelblue", short: "Black holes, time, gravity" },
  English: { color: "bg-pastelyellow", short: "Write stories that stick" },
  History: { color: "bg-pastelpurple", short: "Rome: rise and fall" },
  Chess: { color: "bg-pastelgreen", short: "Openings, tactics, endgames" },
  Robotics: { color: "bg-pastelblue", short: "Build your first robot" },
  Finance: { color: "bg-pastelyellow", short: "Money, credit, investing" },
  Design: { color: "bg-pastelpurple", short: "Color, type, layout" },
  "Personal Development": { color: "bg-pastelgreen", short: "Master emotions, set goals" },
  Chemistry: { color: "bg-pastelblue", short: "Why caffeine wakes you up" },
  Gardening: { color: "bg-pastelyellow", short: "Grow your own food" },
  Marketing: { color: "bg-pastelpurple", short: "How ads (really) work" },
  AI: { color: "bg-pastelblue", short: "Inside ChatGPT and image AI" },
};

const subjectOrder = Object.keys(pillDisplay);

function PlansSection() {
  const plansWithDisplay = loadFeaturedPlans(pillDisplay, subjectOrder);

  return (
    <section data-ga-section="plans" className="bg-white py-20">
      <div className="max-w-screen-lg mx-auto px-6">
        <SectionHeader
          eyebrow="Follow curiosity"
          title="Create a plan for almost anything."
          sub="Eleven-year-olds have asked for plans on stellar nucleosynthesis, competitive chess, and how to run a lemonade stand. Learnforest builds all three."
        />

        {plansWithDisplay.map(({ plan }) =>
          plan.lessons ? <StudyPlanDetailsModal key={plan.subject} studyPlan={plan} /> : null,
        )}

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {plansWithDisplay.map(({ plan, display }) => (
            <button
              key={plan.subject}
              type="button"
              data-ga-cta="plan_modal"
              data-ga-plan={plan.subject}
              className="group flex items-center gap-3 bg-[#fafaf7] hover:bg-white hover:iv1-soft-shadow rounded-2xl p-3 pr-4 transition-all cursor-pointer border border-transparent hover:border-black/5 text-left w-full"
            >
              <div
                className={`w-14 h-14 rounded-full ${display.color} flex items-center justify-center text-2xl shrink-0 border-2 border-white`}
              >
                {plan.image}
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="font-bold text-darkrock text-[14px]">{plan.subject}</h3>
                <div className="text-darkrock/60 text-[12px] leading-tight truncate">{display.short}</div>
              </div>
              <div className="text-darkrock/30 group-hover:text-primary-600 transition">→</div>
            </button>
          ))}
        </div>
        <div className="mt-6 text-center text-darkrock/60 text-[13px]">
          …or type your own goal. The AI will build the plan.
        </div>
      </div>
    </section>
  );
}

export { pillDisplay, subjectOrder };
export default PlansSection;
